import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import ImageSlider from './ImageSlider'

const Images = () => {
  const { modal, itemState } = useItemPage()
  const {
    refs: { imagesRef },
  } = modal
  const { utcEndDateTime, itemClosed, pictureList } = itemState
  return (
    <div className="grid grid-cols-1 item-detail-top" style={{ width: '100%' }}>
      <div className="w-full p-4" ref={imagesRef}>
        <ImageSlider
          pictureList={pictureList}
          date={utcEndDateTime}
          hasEnded={itemClosed}
        />
      </div>
    </div>
  )
}

export default Images
